export function useFormatacaoData() {
  function formatarDataAmericanaParaBrasileira(data) {
    if (!data) return '00/00/0000';
    return data.split("-").reverse().join("/");
  }

  function formatarDataBrasileiraParaAmericana(data) {
    if (!data) return '0000-00-00';
    return data.split("/").reverse().join("-");
  }

  return {
    formatarDataAmericanaParaBrasileira,
    formatarDataBrasileiraParaAmericana,
  }
}
